import {useState, useEffect} from "react";
import {InstalledAppResponse} from "../logic/APITypes";
import API from "../logic/API";
import {Resolution} from "../logic/FetchResolver";

/** A hook for fetching all installed apps from the API */
function useInstalledApps(groupId: string) {
  const [installedApps, setInstalledApps] = useState<InstalledAppResponse[]>(
    [],
  );
  const [loading, setLoading] = useState(true);
  const getInstalledApps = async () => {
    setLoading(true);
    const res: Resolution<InstalledAppResponse[]> =
      await API.getInstalledApps(groupId);
    setLoading(false);
    if (res.success && res.payload) {
      const apps = res.payload.map((app) => {
        return {...app, logo: "data:image/svg+xml;base64," + app.logo};
      });
      setInstalledApps(apps);
    }
  };

  useEffect(() => {
    getInstalledApps();
  }, []);
  return {installedApps, loading};
}

export default useInstalledApps;
